import React from "react";
import styles from "./ThankYouPage.module.css";

const ThankYouPage: React.FC = () => {
  return (
    <div className={styles.container}>
      <h1 className={styles.heading}>THANK YOU FOR YOUR INTEREST!</h1>
      <p className={styles.subheading}>
        Your details have been recorded and you can expect a call from one of
        our expert counselors.
      </p>
      <a href="https://www.regenesys.net/" className={styles.button}>
        Visit Website
      </a>
    </div>
  );
};

export default ThankYouPage;
